import { render, staticRenderFns } from "./ModalCenter.vue?vue&type=template&id=37b4c208&scoped=true"
import script from "./ModalCenter.vue?vue&type=script&lang=js"
export * from "./ModalCenter.vue?vue&type=script&lang=js"
import style0 from "./modal-center.scss?vue&type=style&index=0&id=37b4c208&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b4c208",
  null
  
)

export default component.exports